import { render, staticRenderFns } from "./popViewInvocie.vue?vue&type=template&id=28e7e8ca"
import script from "./popViewInvocie.vue?vue&type=script&lang=js"
export * from "./popViewInvocie.vue?vue&type=script&lang=js"
import style0 from "./popViewInvocie.vue?vue&type=style&index=0&id=28e7e8ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports